import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISelectItem } from '../../../store/models/select.model';
import {
  BillingDesignation,
  BillingDesignationLabels,
  billingDesignationLabel,
} from '../../../store/models/account.model';

@Component({
  selector: 'app-mark-not-billable-dialog',
  templateUrl: './mark-not-billable-dialog.component.html',
  styleUrls: ['./mark-not-billable-dialog.component.scss'],
})
export class MarkNotBillableDialogComponent implements OnInit {

  @Input() inputForm: FormGroup;
  @Input() billingDesignationLabels: BillingDesignationLabels = {};

  designationItems: ISelectItem[] = [];

  ngOnInit(): void {
    this.designationItems = [
      BillingDesignation.QUICKBOOKS,
      BillingDesignation.NO_BILLING,
    ].map(value => ({
      label: billingDesignationLabel(value, this.billingDesignationLabels),
      value,
    }));

    if (!this.inputForm) {
      return;
    }
    this.inputForm.addControl(
      'billing_designation',
      new FormControl(BillingDesignation.QUICKBOOKS, [Validators.required]),
    );
    this.inputForm.addControl('invoice_note', new FormControl('', []));
    this.inputForm.get('billing_designation').valueChanges.subscribe(value => {
      this.updateInvoiceNoteValidators(value);
    });
    this.updateInvoiceNoteValidators(this.inputForm.get('billing_designation').value);
  }

  get showInvoiceNote(): boolean {
    return this.inputForm?.get('billing_designation')?.value === BillingDesignation.NO_BILLING;
  }

  private updateInvoiceNoteValidators(designation: string): void {
    const note = this.inputForm.get('invoice_note');
    if (!note) {
      return;
    }
    if (designation === BillingDesignation.NO_BILLING) {
      note.setValidators([Validators.required]);
    } else {
      note.clearValidators();
      note.setValue('');
    }
    note.updateValueAndValidity();
  }
}
